// extracted by mini-css-extract-plugin
export default {"tableContainer":"styles_tableContainer__TlZVa","tableRow":"styles_tableRow__HZeEt","tableRowItem":"styles_tableRowItem__gpszI","viewBtn":"styles_viewBtn__zVPtx"};